export default "__VITE_PUBLIC_ASSET__48703c18__"